export default "__VITE_ASSET__37dfd308__"